const o = {
  id: "PowerBallXsAndOs",
  logo: !0,
  name: "Powerball Xs & Os™",
  style: {
    colorPrimary: "#39B54A"
  }
};
export {
  o as default
};
